import React, { useEffect, useState } from "react";

const HtmlRenderer = ({ file }) => {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch(`/generated-html/${file}.html`)
      .then((res) => {
        if (!res.ok) throw new Error(`Ошибка загрузки ${file}.html`);
        return res.text();
      })
      .then(setContent)
      .catch((err) => console.error("Ошибка загрузки HTML:", err));
  }, [file]);

  return (
    <div
      className="content-format"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default HtmlRenderer;
